export default __webpack_public_path__ + "static/media/cancel_interview_cross.88fcc216.svg";